import { render } from "./ServiceCoupons.vue?vue&type=template&id=d8dde184&lang=true"
import script from "./ServiceCoupons.vue?vue&type=script&lang=js"
export * from "./ServiceCoupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/ServiceCoupons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8dde184"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8dde184', __exports__)) {
    api.reload('d8dde184', __exports__)
  }
  
  module.hot.accept("./ServiceCoupons.vue?vue&type=template&id=d8dde184&lang=true", () => {
    api.rerender('d8dde184', render)
  })

}


export default __exports__